<div id="ht">
  <div id="main-cnt">
    <ion-header class="main-header block">
      <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
          <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
            <span class="breadcrumb">Support</span>
          </div>
        </ion-buttons>
        <div slot="end" class="notification-div">

          <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">

            <img [src]="sessionService?.user?.profileImg|s3Link"/>
          </ion-avatar>
        </div>
        <app-add-bookmark slot="end"
                pageTitle="Supporto"
                url="/support"
        ></app-add-bookmark>
      </ion-toolbar><ion-toolbar><ion-text><p class="ion-text-wrap">{{title}}</p></ion-text></ion-toolbar>
      <br />
    </ion-header>

    <ion-content class="main-dcontent">
      <div class="scroller-container">
        <div class="content-scroller">
          <div class="content">
            <!-- edit da qui... -->

            <app-support-chat [ticketId]="ticketId"></app-support-chat>

            <!-- ...a qui -->
          </div>
        </div>
      </div>
    </ion-content>
  </div>
</div>
